/**
 * AdsPixelTracker — mount once inside <BrowserRouter>. Loads the OpenAI
 * (ChatGPT Ads) Measurement Pixel the first time the visitor is on a
 * marketing route and sends one `page_viewed` per marketing route change.
 * Never loads or pings on portal / booking pages. Renders nothing.
 * See lib/adsPixel.js for the route allow-list and privacy rationale.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isMarketingPath, trackAdsPageView } from '@/lib/adsPixel';

export const AdsPixelTracker = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (!isMarketingPath(pathname)) return undefined;
        // Small delay so react-helmet has applied the page <title> first.
        const t = setTimeout(() => trackAdsPageView(pathname), 250);
        return () => clearTimeout(t);
    }, [pathname]);
    return null;
};

export default AdsPixelTracker;
